import { useEffect, useState } from "react";
import { FiCheck, FiCircle, FiLock } from "react-icons/fi";
import styles from "./AnalysisLoading.module.css";

const getStepStatus = (step, index, activeStep) => {
  if (typeof step !== "string" && step.status) return step.status;
  if (index < activeStep) return "complete";
  if (index === activeStep) return "loading";
  return "pending";
};

const AnalysisLoading = ({
  show = true,
  title,
  subtitle,
  steps = [],
  footer,
  mode = "embedded",
  size = "regular",
  isGuarantor = false,
  className = "",
  stepDelay = 900,
  loaderSrc,
}) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    setActiveStep(0);

    if (!show || steps.length <= 1) return undefined;

    const timers = Array.from({ length: steps.length - 1 }, (_, index) =>
      window.setTimeout(() => setActiveStep(index + 1), stepDelay * (index + 1))
    );

    return () => timers.forEach((timer) => window.clearTimeout(timer));
  }, [show, stepDelay, steps.length]);

  if (!show) return null;

  const content = (
    <div
      className={`${styles.content} ${styles[size] || ""} ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {loaderSrc ? (
        <img
          src={loaderSrc}
          className={styles.loader}
          alt=""
          aria-hidden="true"
        />
      ) : (
        <span className={styles.spinner} aria-hidden="true" />
      )}

      <div className={styles.intro}>
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>

      <div className={styles.steps}>
        {steps.map((step, index) => {
          const label = typeof step === "string" ? step : step.label;
          const status = getStepStatus(step, index, activeStep);

          return (
            <div
              className={styles.step}
              key={`${index}-${label}`}
              data-status={status}
              aria-label={`${label}: ${status}`}
            >
              {status === "complete" && <FiCheck aria-hidden="true" />}
              {status === "loading" && (
                <span className={styles.stepSpinner} aria-hidden="true" />
              )}
              {status === "pending" && <FiCircle aria-hidden="true" />}
              <span className={status === "pending" ? styles.pending : ""}>
                {label}
              </span>
            </div>
          );
        })}
      </div>

      {footer && (
        <div className={styles.footer}>
          <FiLock aria-hidden="true" />
          <span>{footer}</span>
        </div>
      )}
    </div>
  );

  if (mode === "modal") {
    return (
      <div
        className={`popup-overlay fixed inset-0 modal-fixed-screen flex z-50 wrapper-modal ${styles.overlay} ${isGuarantor ? "guarantorBg" : ""}`}
      >
        <div
          className={styles.card}
          onClick={(event) => event.stopPropagation()}
        >
          {content}
        </div>
      </div>
    );
  }

  return content;
};

export default AnalysisLoading;
